import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SkillRepoEmployeesService } from '../../skill-repo-employees/skill-repo-employees.service';
import { CompetenciesService } from '../competencies.service';
import { forkJoin } from 'rxjs';



@Component({
  selector: 'app-servicelines-sidebar',
  templateUrl: './servicelines-sidebar.component.html',
  styleUrls: ['./servicelines-sidebar.component.css']
})
export class ServicelinesSidebarComponent implements OnInit {
  @Input() cardWidth: string = '100%';
  @Input() paddingLeft: string = '8vw';
  @Input() paddingRight: string = '8vw';
  @Input() paddingBottom: string = '35px';
  @Input() rowGap: string = '3vw';
  @Input() columnGap: string = '6.85';
  @Input() cardColor: string = '#FFF';
  @Input() flag: boolean = false;
  @Input() checkFlag: boolean = false;
  @Input() skills: any = [
    // {name:'Digital Workspace Services'},
    // {name:'Cloud Infrastructure Services'},
    // {name:'Cloud Engineering Services'},
    // {name:'Cloud Management'},
    // {name:'Cloud Analaytics& Intelligence'}
  ];
  services: any = [];
  @Input() applyMinHeight: boolean = false;
  isCardOpen = true;
  constructor(private compservice: CompetenciesService, private route: ActivatedRoute, private service: SkillRepoEmployeesService) { }
  competencyId: number;
  serviceId: number;
  servicename: any;
  selectedIndex: any;
  compId: number;
  resourceWidgetData: any;
  @Output() serviceLine: any=new EventEmitter();


  ngOnInit() {
    this.competencyId = Number(sessionStorage.getItem("compId"));
    if (this.competencyId) {
      this.GetSeviceLineareas(this.competencyId)
       
    }
    //this.getCompetencyLevelCounts(this.competencyId),
  }

  toggleFlag() {
    this.compservice.toggleFlag();
  }

  getCompetencyLevelCounts(competencyId) {
    this.compservice.GetCompetencyLevelCounts(competencyId).subscribe(res => {
      this.skills = res.data;
    })

  }
  openservicelines(service) { 
    this.selectedIndex = service.id - 1;
    this.serviceId = service.id;
    this.compservice.setServiceLine(this.serviceId)
    this.servicename = service.name;
    this.compservice.updateServiceId(this.serviceId);
    sessionStorage.setItem("SubcompTitle", service.name);
    sessionStorage.setItem("SubcompId", service.id);
    this.serviceLine.emit(service);
    //console.log("selected service", service);
    
  }



  GetSeviceLineareas(competencyId) {

    this.compservice.GetServices(competencyId).subscribe((res) => {
      //console.log("result now 1: ", res);
      
      this.services = res.data;
      this.openservicelines(this.services[0]);
    })

  }
}
